import { environment } from '@et/environment';
import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { AuthService } from '@et/auth';
import { ETPermissions } from '@et/typings';
import { Store } from '@ngxs/store';
import { ProfileState } from '@et/guards';

@Component({
  selector: 'et-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NavbarComponent {
  private authService = inject(AuthService);
  private store = inject(Store);

  showProfileMenu = false;
  isProd = environment.production;
  permissions = ETPermissions;
  isAdminHovered = false;
  isAdmin$ = this.store.select(ProfileState.getIsCompanyAdmin);
  /**
   * Log out the user.
   * @returns None
   * @memberof NavbarComponent
   */
  logout(): void {
    this.authService.logout();
  }
  /**
   * close profile menu when clicking out of element
   *
   * @param {MouseEvent} ev
   * @memberof NavbarComponent
   */
  closeProfileMenu(ev: MouseEvent) {
    ev.stopPropagation();
    if (this.showProfileMenu) {
      this.showProfileMenu = false;
    }
  }
}
